import React from 'react'
import CodieImg from '../Assets/codie_transparent.png'
import { BsPlayCircleFill } from 'react-icons/bs'

const Landing = () => {
    return (
        <div className='landing-container'>
            <div className='landing-container-left'>
                <h1>Master your <span className='color-primary'>Coding Interviews</span> with Codie - Your Interview prep buddy</h1>
                <p>Codie is your ultimate AI powered chatbot to help you prepare for interviews. Codie helps you prepare better, faster and more efficiently for your interviews. Codie is supported on most of the popular platforms such as Leetcode, Hackerrank, Algoexpert and more.</p>
                <div className='landing-btns'>
                    <a href="https://chrome.google.com/webstore/detail/codie/alokfiajmmedmneninfkldildipgjemf/" target='_blank' rel="noreferrer"><button className='try-btn'>Try now for free!</button></a>
                    <a href="https://youtu.be/JT8Rb2zLk8U" target='_blank' rel='noreferrer'><button className='demo-btn'><BsPlayCircleFill /> Watch Demo</button></a>
                </div>
            </div>
            <div className='landing-container-right'>
                <img src={CodieImg} alt="codie" />
            </div>
            {/* <p>Early access</p> */}
        </div>
    )
}

export default Landing